import { render } from "./LeaveDashboardView.vue?vue&type=template&id=96b5f722&scoped=true"
import script from "./LeaveDashboardView.vue?vue&type=script&lang=js"
export * from "./LeaveDashboardView.vue?vue&type=script&lang=js"

import "./LeaveDashboardView.vue?vue&type=style&index=0&id=96b5f722&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96b5f722"]])

export default __exports__